<template
  ><footer>
    <div class="bg-light py-5">
      <div class="container"><div>PhysioFooter</div></div>
    </div>
    <div class="container">
      <div class="row pt-2 pb-1" style="font-size: 12px; max-height:24px">
        <div class="col text-left">
          <p><MadeWithLove /></p>
        </div>
        <div class="col text-center text-light2">
          <p v-b-tooltip.top="`version: ${version} - ${gitSHA}`">
            <b>{{ version }}</b>
          </p>
        </div>
        <div class="col text-right">
          <b-link :to="{ name: 'about' }" class="pr-3">{{
            $t('about')
          }}</b-link>
          <b-link :to="{ name: 'legal' }" class="pr-3">{{
            $t('legal')
          }}</b-link>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
import config from '@/config';
import MadeWithLove from '@/elements/MadeWithLove';

export default {
  name: 'FooterPhysio',
  components: { MadeWithLove },
  computed: {
    version: () => config.version,
    gitSHA: () => config.gitSHA,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/FooterPhysio.vue